var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.296,
    height: 26.237,
    viewBox: "0 0 28.296 26.237",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 0.898,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#338fee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43c6fe"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Icon_material-mail-outline",
    x: 0,
    y: 0,
    width: 28.296,
    height: 26.237,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_116820",
    "data-name": "Group 116820",
    transform: "translate(10590.147 13202.117)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_269",
    "data-name": "Ellipse 269",
    transform: "translate(-10586.001 -13202)",
    fill: "#141623",
    stroke: "#42c3fd",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -10590.15, -13202.12)",
    filter: "url(#Icon_material-mail-outline)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-mail-outline-2",
    "data-name": "Icon material-mail-outline",
    d: "M12.267,6H4.03A1.028,1.028,0,0,0,3.005,7.03L3,13.207a1.033,1.033,0,0,0,1.03,1.03h8.237a1.033,1.033,0,0,0,1.03-1.03V7.03A1.033,1.033,0,0,0,12.267,6Zm0,7.207H4.03V8.059l4.119,2.574,4.119-2.574ZM8.148,9.6,4.03,7.03h8.237Z",
    transform: "translate(6)",
    fill: "url(#linear-gradient)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail3);
export default __webpack_public_path__ + "static/media/Email3.5f844dc2e2179a457da9f9eac4266144.svg";
export { ForwardRef as ReactComponent };